const availablePrimaries = [
    'default',
    'marketing',
    'patterns',
    'orders',
    'agencies',
    'dynamic_matching',
    'project_management',
] as const;

export enum PrimaryPositionEnum {
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
    TERNARY = 'ternary',
}

type PrimariesTuple = typeof availablePrimaries;

export type PrimaryType = PrimariesTuple[number];
export const isPrimaryType = (type: string): type is PrimaryType => availablePrimaries.includes(type as PrimaryType);

export type PrimarySize = 'S' | 'M' | 'L' | 'XL' | 'NONE';

export type PrimaryRatio = [PrimarySize, PrimarySize];

export const M_M: PrimaryRatio = ['M', 'M'];
export const L_S: PrimaryRatio = ['L', 'S'];
export const S_L: PrimaryRatio = ['S', 'L'];
export const XL: PrimaryRatio = ['XL', 'NONE'];

export const ratiosEqual = (primaryRatio1: PrimaryRatio, primaryRatio2: PrimaryRatio): boolean =>
    primaryRatio1[0] === primaryRatio2[0] && primaryRatio1[1] === primaryRatio2[1];
